export const jsonParse = <T=any>(value: string | undefined) => {
  if (!value) return undefined;
  try {
    return JSON.parse(value) as T;
  } catch (e) {
    return undefined;
  }
};
export const jsonStringify = (value: any) => {
  if (!value) return undefined;
  try {
    return JSON.stringify(value);
  } catch (e) {
    return undefined;
  }
};
